export default function copyLink() {
  const nodelist = document.querySelectorAll('.js-copyLink');
  const elements = Array.prototype.slice.call(nodelist,0);

  const handleCopyClipboard = async text => {
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(text);
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    }

    const span = document.createElement('span');

    span.textContent = text;
    span.style.webkitUserSelect = 'auto';
    span.style.position = 'fixed';
    span.style.right = '1000%';

    document.body.appendChild(span);
    document.getSelection().selectAllChildren(span);
    document.execCommand('copy');
    document.body.removeChild(span);

    return Promise.resolve();
  };

  elements.forEach(function(element) {
    const link = element.querySelector('a');
    link.addEventListener('click', (e) => {
      const text = e.currentTarget.href;
      handleCopyClipboard(text).then(
        function () {
          const feedback = element.querySelector('.copy__feedback');
          feedback.setAttribute('aria-hidden', false);
          setTimeout(function(){
            feedback.setAttribute('aria-hidden', true);
          }, 2400);
        }
      );
      e.preventDefault();
    });
  });
}

copyLink();
